import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {rpAppLink} from "@pg-mono/rp-routes";

import {PropertyCarouselTile} from "../../../property/components/property_carousel/PropertyCarouselTile";
import {getPropertyRegionLocation} from "../../../property/utils/get_property_region_location";
import {useAppSelector} from "../../../store/hooks";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {hitAiAssistantOffer} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeSemanticSearchSelectItem} from "../../tracking/track_amplitude_semantic_search_select_item";
import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";

interface Props {
    property: SemanticSearchPropertyDto;
    index: number;
}

export function SemanticSearchPropertyListTile(props: Props) {
    const {property, index} = props;
    const modalSize = useAppSelector((state) => getSemanticSearchModalSize(state.semanticSearchModal.surfacePhase));

    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });

    const imageSrc = getThumbnailLink(property.offer.main_image_url, 308, 256);

    return (
        <PropertyCarouselTile
            href={propertyLink}
            imageSrc={imageSrc}
            investmentName={property.offer.name}
            rooms={property.rooms}
            area={property.area}
            floor={property.floor}
            price={property.price}
            location={getPropertyRegionLocation(property.offer.region, property.offer.address)}
            onClick={() => {
                hitAiAssistantOffer("select", property);

                trackAmplitudeSemanticSearchSelectItem({
                    modalSize,
                    analyticSessionId: getAnalyticsSessionId(),
                    item: {itemCategory: "property", property, index}
                });
            }}
        />
    );
}
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {rpAppLink} from "@pg-mono/rp-routes";

import {PropertyCarouselTile} from "../../../property/components/property_carousel/PropertyCarouselTile";
import {getPropertyRegionLocation} from "../../../property/utils/get_property_region_location";
import {useAppSelector} from "../../../store/hooks";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {hitAiAssistantOffer} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeSemanticSearchSelectItem} from "../../tracking/track_amplitude_semantic_search_select_item";
import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";

interface Props {
    property: SemanticSearchPropertyDto;
    index: number;
}

export function SemanticSearchPropertyListTile(props: Props) {
    const {property, index} = props;
    const modalSize = useAppSelector((state) => getSemanticSearchModalSize(state.semanticSearchModal.surfacePhase));

    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });

    const imageSrc = getThumbnailLink(property.offer.main_image_url, 308, 256);

    return (
        <PropertyCarouselTile
            href={propertyLink}
            imageSrc={imageSrc}
            investmentName={property.offer.name}
            rooms={property.rooms}
            area={property.area}
            floor={property.floor}
            price={property.price}
            location={getPropertyRegionLocation(property.offer.region, property.offer.address)}
            onClick={() => {
                hitAiAssistantOffer("select", property);

                trackAmplitudeSemanticSearchSelectItem({
                    modalSize,
                    analyticSessionId: getAnalyticsSessionId(),
                    item: {itemCategory: "property", property, index}
                });
            }}
        />
    );
}
